import { combineReducers } from 'redux';

import departureCityReducer from './departure-city/departureCity.reducer';
import departureDateReducer from './departure-date/departureDate.reducer';
import durationReducer from './duration/duration.reducer';
import { flexibilityReducer } from './flexibility/flexibility.reducer';

export default combineReducers({
  departureCity: departureCityReducer,
  departureDate: departureDateReducer,
  duration: durationReducer,
  flexibility: flexibilityReducer,
});
